export default "icons-zoom-out"